import { CallRecordOpenItemTable } from "../CallRecordOpenItemTable";
import { Attachment, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutARCallRecord extends Layout {
    attachmentAttachment: Attachment;
    labelCallDetailsSection: Label;
    labelItemsDiscussedSection: Label;
    labelNextActionsSection: Label;
    layoutCallRecordOpenItemTable: CallRecordOpenItemTable;
    panelCallDetails: Panel;
    panelItemsDiscussed: Panel;
    panelNextActions: Panel;
    sourceArCallRecord: DataSource;
    sourceCallRecOpenItem: DataSource;
    textboxCallActionCode: Textbox;
    textboxCallDateTime: Textbox;
    textboxCallDetail: Textbox;
    textboxCaller: Textbox;
    textboxContacted: Textbox;
    textboxCustomerCode: Textbox;
    textboxEmail: Textbox;
    textboxNextAction: Textbox;
    textboxNextActionDate: Textbox;
    textboxPhone: Textbox;
    textboxRemark: Textbox;
    textboxTitle: Textbox;
}
